import { defineActions } from './defineActions'

/**
 * Page shell / footer of the IME detail page. Action names start with Ime.
 *
 * The footer Save (and the "Save?" prompt shown when a changed section is collapsed, another
 * section is opened or the page is refreshed) saves the open section, so its action is picked
 * from the page's current step (see getImeSaveActionName in pages/assessment/assessment-details).
 * Other areas reuse these names for the same save; never declare them again elsewhere.
 */
export const imePageActions = defineActions({
  'Ime.Case.Create': { label: 'Create case', area: 'Case' },
  'Ime.Case.Save': {
    label: 'Save case',
    area: 'Case',
    description: 'Footer Save while a section without its own save is open.',
  },
  'Ime.Case.SaveFromQuotationInit': {
    label: 'Create booking from quotation',
    area: 'Quotation',
    description: 'Footer Save after "Create Booking" on an OT quotation.',
  },
  'Ime.BookingDetails.Save': {
    label: 'Save booking details',
    area: 'Booking details',
    description:
      'Footer Save on Booking Company, Claim Information, Booking Notes or Case Permission.',
  },
  'Ime.Quotation.Create': { label: 'Create quotation', area: 'Quotation' },
  'Ime.Quotation.Save': { label: 'Save quotation', area: 'Quotation' },
  'Ime.Appointment.Save': { label: 'Save appointment', area: 'Appointment' },
  'Ime.Paperwork.Save': { label: 'Save paperwork', area: 'Paperwork' },
  'Ime.Attendance.Save': { label: 'Save attendance', area: 'Attendance' },
  'Ime.Dictation.Save': {
    label: 'Save dictation & report',
    area: 'Dictation & report',
  },
  'Ime.Payment.Save': { label: 'Save payment', area: 'Payment' },
  'Ime.Cancellation.Save': {
    label: 'Save cancellation',
    area: 'Cancellation',
  },
})
